module.exports = __webpack_public_path__ + "media/images/pages/inspire_with_computing_ambassador/flourish-d4615d54f275b30762af68f32cf4c84f.svg";